import React from "react";
import "./Components.css";

function TasteProfilePoster({ profile, scores, topArtists, topTracks }) {
  if (!profile || !scores) return null;

  const getDimensionColor = (score) => {
    // Create a gradient from blue (0) to red (1)
    const hue = (1 - score) * 240; // 240 is blue, 0 is red
    return `hsl(${hue}, 70%, 60%)`;
  };

  return (
    <div id="taste-profile-poster" className="taste-profile-poster">
      <div className="taste-profile-content">
        {/* Header */}
        <div className="poster-header">
          <div className="poster-emoji">{profile.emoji}</div>
          <div className="poster-title-section">
            <h1 className="poster-title">{profile.name}</h1>
            <p className="poster-subtitle">Your Spotify Taste Profile</p>
          </div>
        </div>

        {/* Description */}
        <div className="poster-description">
          <p>{profile.description}</p>
        </div>

        {/* Dimensions Grid */}
        <div className="dimensions-grid">
          <div className="dimension-item">
            <div className="dimension-label">Energy</div>
            <div className="dimension-bar">
              <div
                className="dimension-fill"
                style={{
                  width: `${scores.energy * 100}%`,
                  backgroundColor: getDimensionColor(scores.energy),
                }}
              />
            </div>
            <div className="dimension-value">{profile.dimensions.energy.label}</div>
            <div className="dimension-percentage">{Math.round(scores.energy * 100)}%</div>
          </div>

          <div className="dimension-item">
            <div className="dimension-label">Diversity</div>
            <div className="dimension-bar">
              <div
                className="dimension-fill"
                style={{
                  width: `${scores.diversity * 100}%`,
                  backgroundColor: getDimensionColor(scores.diversity),
                }}
              />
            </div>
            <div className="dimension-value">{profile.dimensions.diversity.label}</div>
            <div className="dimension-percentage">{Math.round(scores.diversity * 100)}%</div>
          </div>

          <div className="dimension-item">
            <div className="dimension-label">Modernity</div>
            <div className="dimension-bar">
              <div
                className="dimension-fill"
                style={{
                  width: `${scores.modernity * 100}%`,
                  backgroundColor: getDimensionColor(scores.modernity),
                }}
              />
            </div>
            <div className="dimension-value">{profile.dimensions.modernity.label}</div>
            <div className="dimension-percentage">{Math.round(scores.modernity * 100)}%</div>
          </div>

          <div className="dimension-item">
            <div className="dimension-label">Mood</div>
            <div className="dimension-bar">
              <div
                className="dimension-fill"
                style={{
                  width: `${scores.mood * 100}%`,
                  backgroundColor: getDimensionColor(scores.mood),
                }}
              />
            </div>
            <div className="dimension-value">{profile.dimensions.mood.label}</div>
            <div className="dimension-percentage">{Math.round(scores.mood * 100)}%</div>
          </div>
        </div>

        {/* Top Artists and Tracks */}
        {topArtists && topArtists.length > 0 && (
          <div className="top-lists-container">
            <div className="top-list">
              <h3 className="top-list-title">Top Artists (Last Month)</h3>
              <ol className="top-list-items">
                {topArtists.map((artist, index) => (
                  <li key={artist.id} className="top-list-item">
                    <span className="item-rank">{index + 1}</span>
                    <span className="item-name">{artist.name}</span>
                  </li>
                ))}
              </ol>
            </div>

            {topTracks && topTracks.length > 0 && (
              <div className="top-list">
                <h3 className="top-list-title">Top Tracks (Last Month)</h3>
                <ol className="top-list-items">
                  {topTracks.map((track, index) => (
                    <li key={track.id} className="top-list-item">
                      <span className="item-rank">{index + 1}</span>
                      <span className="item-name">
                        {track.name}
                        <span className="item-artist"> • {track.artists[0].name}</span>
                      </span>
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>
        )}

        {/* Footer */}
        <div className="poster-footer">
          <p className="footer-text">Generated by Spotify Taste Profile</p>
          <p className="footer-date">{new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
}

export default TasteProfilePoster;
